import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { productosPlacards } from '../../data/productos';

const ProductosPlacards = () => {
  const [showMoreSinBaulera, setShowMoreSinBaulera] = useState(false);
  const [showMoreConBaulera, setShowMoreConBaulera] = useState(false);
  const [isHidingSinBaulera, setIsHidingSinBaulera] = useState(false);
  const [isHidingConBaulera, setIsHidingConBaulera] = useState(false);
  
  // Función para manejar el toggle y scroll de Sin Baulera
  const handleToggleSinBaulera = () => {
    if (showMoreSinBaulera) {
      // Si estamos mostrando más y vamos a ocultar, iniciar scroll primero
      document.getElementById('placards').scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
      
      // Iniciar animación de desvanecimiento después de un pequeño delay
      setTimeout(() => {
        setIsHidingSinBaulera(true);
      }, 200);
      
      // Ocultar productos después de que termine la animación
      setTimeout(() => {
        setShowMoreSinBaulera(false);
        setIsHidingSinBaulera(false);
      }, 1000); // 200ms delay + 800ms animación
    } else {
      // Si vamos a mostrar más, solo cambiar el estado
      setShowMoreSinBaulera(true);
    }
  };
  
  // Función para manejar el toggle y scroll de Con Baulera
  const handleToggleConBaulera = () => {
    if (showMoreConBaulera) {
      // Si estamos mostrando más y vamos a ocultar, iniciar scroll primero
      document.getElementById('placards-con-baulera').scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
      
      // Iniciar animación de desvanecimiento después de un pequeño delay
      setTimeout(() => {
        setIsHidingConBaulera(true);
      }, 200);
      
      // Ocultar productos después de que termine la animación
      setTimeout(() => {
        setShowMoreConBaulera(false);
        setIsHidingConBaulera(false);
      }, 1000); // 200ms delay + 800ms animación
    } else {
      // Si vamos a mostrar más, solo cambiar el estado
      setShowMoreConBaulera(true);
    }
  };
  
  // Separar productos por tipo (sin baulera y con baulera)
  const productosArray = Object.entries(productosPlacards);
  const productosSinBaulera = productosArray.filter(([productId, product]) => 
    !productId.includes('placard_y_baulera')
  );
  const productosConBaulera = productosArray.filter(([productId, product]) => 
    productId.includes('placard_y_baulera')
  );

  // Dividir en grupos para "Ver más"
  const sinBauleraIniciales = productosSinBaulera.slice(0, 3);
  const sinBauleraAdicionales = productosSinBaulera.slice(3);
  
  const conBauleraIniciales = productosConBaulera.slice(0, 3);
  const conBauleraAdicionales = productosConBaulera.slice(3);

  return (
    <section className="products-section placards-section" id="placards">
      <div className="section-container">
        <h2 className="section-title placards-title">Placards</h2>
        <div className="placards-subtitle-container">
          <p className="section-subtitle placards-subtitle">Lo mejor de nuestra tienda en esta sección</p>
        </div>
        
        {/* Subsección: Placards Sin Baulera */}
        <div className="placards-subsection">
          <h3 className="subsection-title">Sin Baulera</h3>
          {/* Productos iniciales sin baulera (siempre visibles) */}
          <div className="products-grid">
            {sinBauleraIniciales.map(([productId, product]) => (
              <Link key={productId} to={`/producto/${productId}`} className="product-placeholder">
                <div 
                  className="placeholder-image" 
                  style={{backgroundImage: `url(${product.images[0]})`}}
                ></div>
                <div className="placeholder-content">
                  <div className="product-name-container">
                    <h3 className="product-name">🔥 {product.name.toUpperCase()} ⚡</h3>
                  </div>
                  <div className="product-price-container">
                    <p className="product-price">💰 {product.price} 💰</p>
                  </div>
                </div>
              </Link>
            ))}
          </div>
          
          {/* Productos adicionales sin baulera (condicionales) */}
          {showMoreSinBaulera && (
            <div className={`additional-products ${isHidingSinBaulera ? 'hiding' : ''}`}>
              {sinBauleraAdicionales.map(([productId, product]) => (
                <Link key={productId} to={`/producto/${productId}`} className="product-placeholder">
                  <div 
                    className="placeholder-image" 
                    style={{backgroundImage: `url(${product.images[0]})`}}
                  ></div>
                  <div className="placeholder-content">
                    <div className="product-name-container">
                      <h3 className="product-name">🔥 {product.name.toUpperCase()} ⚡</h3>
                    </div>
                    <div className="product-price-container">
                    <p className="product-price">💰 {product.price} 💰</p>
                  </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
          
          {/* Botón Ver más/Ver menos para sin baulera */}
          {sinBauleraAdicionales.length > 0 && (
            <div className="show-more-container">
              <button
                className="show-more-button"
                onClick={handleToggleSinBaulera}
              >
                {showMoreSinBaulera ? 'Ver menos' : 'Ver más'}
              </button>
            </div>
          )}
        </div>

        {/* Subsección: Placards Con Baulera */}
        <div className="placards-subsection" id="placards-con-baulera">
          <h3 className="subsection-title">Con Baulera</h3>
          {/* Productos iniciales con baulera (siempre visibles) */}
          <div className="products-grid">
            {conBauleraIniciales.map(([productId, product]) => (
              <Link key={productId} to={`/producto/${productId}`} className="product-placeholder">
                <div 
                  className="placeholder-image" 
                  style={{backgroundImage: `url(${product.images[0]})`}}
                ></div>
                <div className="placeholder-content">
                  <div className="product-name-container">
                    <h3 className="product-name">🔥 {product.name.toUpperCase()} ⚡</h3>
                  </div>
                  <div className="product-price-container">
                    <p className="product-price">💰 {product.price} 💰</p>
                  </div>
                </div>
              </Link>
            ))}
          </div>
          
          {/* Productos adicionales con baulera (condicionales) */}
          {showMoreConBaulera && (
            <div className={`additional-products ${isHidingConBaulera ? 'hiding' : ''}`}>
              {conBauleraAdicionales.map(([productId, product]) => (
                <Link key={productId} to={`/producto/${productId}`} className="product-placeholder">
                  <div 
                    className="placeholder-image" 
                    style={{backgroundImage: `url(${product.images[0]})`}}
                  ></div>
                  <div className="placeholder-content">
                    <div className="product-name-container">
                      <h3 className="product-name">🔥 {product.name.toUpperCase()} ⚡</h3>
                    </div>
                    <div className="product-price-container">
                    <p className="product-price">💰 {product.price} 💰</p>
                  </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
          
          {/* Botón Ver más/Ver menos para con baulera */}
          {conBauleraAdicionales.length > 0 && (
            <div className="show-more-container">
              <button
                className="show-more-button"
                onClick={handleToggleConBaulera}
              >
                {showMoreConBaulera ? 'Ver menos' : 'Ver más'}
              </button>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ProductosPlacards;
